import { render } from "./Rooms.vue?vue&type=template&id=0cbf4f7b&ts=true"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__